<p-table [showGridlines]="true" [value]="searchResult?.Result" [rows]="searchParams ? searchParams.PageSize : 20"
  [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)" [lazyLoadOnInit]="false" [lazy]="true"
  [loading]="loading">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="Link">
        {{ 'communications.mass-comm-message-admin.analytics.top-five-links-grid.link' | translate | ucfirst }}
        <p-sortIcon field="Link"></p-sortIcon>
      </th>
      <th pSortableColumn="ClickCount">
        {{ 'communications.mass-comm-message-admin.analytics.top-five-links-grid.click-count' | translate | ucfirst }}
        <p-sortIcon field="EmailOpens"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-link>
    <tr>
      <td>
        <a [href]="link.Link" target="_blank">{{ link.Link | ellipsisTruncater: 80 }}</a>
      </td>
      <td style="min-width: 150px">
        {{ link.ClickCount }}
      </td>
    </tr>
  </ng-template>
</p-table>
